import { render, staticRenderFns } from "./after_sale_detail.vue?vue&type=template&id=4f6f1555&scoped=true"
import script from "./after_sale_detail.vue?vue&type=script&lang=js"
export * from "./after_sale_detail.vue?vue&type=script&lang=js"
import style0 from "./after_sale_detail.vue?vue&type=style&index=0&id=4f6f1555&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f1555",
  null
  
)

export default component.exports